import { render, staticRenderFns } from "./InvestorOnboardingGender.vue?vue&type=template&id=f99ba298&"
import script from "./InvestorOnboardingGender.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports